import { boardsApi } from '../../../api';
import type { Board, CreateBoardInput } from '../../../types';
import type { BoardStateSetter } from '../types';

export const createCreateBoard = (set: BoardStateSetter) => {
  return async (input: CreateBoardInput): Promise<Board> => {
    const board = await boardsApi.create(input);
    set((state) => ({ boards: [...state.boards, board] }));
    return board;
  };
};
